import { Search, Ruler, Hammer } from "lucide-react";
import SectionFadeIn from "@/components/SectionFadeIn";

const journey = [
  {
    icon: Search,
    step: "01",
    title: "Choose a Design",
    desc: "Browse our mural collection or send us any image. We carry nature scenes, abstract art, cityscapes, and more.",
  },
  {
    icon: Ruler,
    step: "02",
    title: "Send Us Your Wall Dimensions",
    desc: "Measure your wall width and height. We scale the artwork to fit perfectly and quote based on total m\u00b2 and your choice of wallpaper or vinyl material.",
  },
  {
    icon: Hammer,
    step: "03",
    title: "We Print, You Install",
    desc: "Printed on premium paste-the-wall, textured, or peel & stick material. From \u00a314\u2013\u00a322/m\u00b2 depending on finish. Professional installation available.",
  },
];

export function MuralJourney() {
  return (
    <section
      className="pt-20 pb-28 md:pt-24 md:pb-36 max-w-7xl mx-auto px-6 md:px-12"
      data-testid="mural-journey-section"
    >
      <SectionFadeIn>
        <div className="max-w-lg">
          <p className="text-[11px] tracking-[0.25em] uppercase font-semibold text-brand-gold mb-3">
            How It Works
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight text-brand-text leading-tight">
            From Screen to Wall
            <br className="hidden sm:block" /> in Three Steps
          </h2>
        </div>
      </SectionFadeIn>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        {journey.map((j, i) => (
          <SectionFadeIn key={j.step} delay={i * 120}>
            <div data-testid={`journey-step-${j.step}`}>
              <div className="flex items-center gap-4 mb-5">
                <span className="text-3xl font-heading text-brand-gold/20 leading-none">
                  {j.step}
                </span>
                <j.icon
                  size={22}
                  strokeWidth={1.6}
                  className="text-brand-gold"
                />
              </div>
              <h3 className="font-body text-[15px] font-semibold text-brand-text mb-2">
                {j.title}
              </h3>
              <p className="text-[13px] text-brand-text-secondary leading-relaxed">
                {j.desc}
              </p>
            </div>
          </SectionFadeIn>
        ))}
      </div>
    </section>
  );
}
